import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import styled, { css } from 'styled-components';
import neutral from '../../themes/neutral/index.js';
import { addPx } from '../../themes/utils.js';
import { createGlobalStyle } from '../global-styles.js';
import Button from '../Button/Button.js';

var _templateObject;
var animationSpeed = 200;
var edgePadding = neutral.spacings.medium;
var animations = css(["&.modal-appear,&.modal-appear-active,&.modal-appear-done,&.modal-enter,&.modal-enter-active,&.modal-enter-done,&.modal-exit,&.modal-exit-active{display:flex;transition:opacity ", "s ease-in;}&.modal-appear,&.modal-enter{opacity:0;}&.modal-appear-active,&.modal-enter-active,&.modal-enter-done{opacity:1;}&.modal-exit{opacity:1;}&.modal-exit-active,&.modal-exit-done{opacity:0;}&.modal-exit-done{display:none;}"], animationSpeed / 1000);
var StyledOverlay = styled.div.withConfig({
  displayName: "Modalstyles__StyledOverlay",
  componentId: "sc-yqascu-0"
})(["position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,0.45);display:none;", ""], animations);
var StyledModal = styled.div.withConfig({
  displayName: "Modalstyles__StyledModal",
  componentId: "sc-yqascu-1"
})(["font-family:", ";position:fixed;margin:3rem auto;top:0;right:0;bottom:0;left:0;background-color:white;height:auto;max-width:800px;box-shadow:0px 0px 20px 0px #0000004D;display:none;flex-direction:column;min-height:40vh;max-height:80vh;width:60vw;", " @media (max-width:", "){width:80%;}@media (max-width:", "){height:100%;width:100%;margin:0;max-height:none;.modal-footer{button{width:100%;:not(:first-child){margin-top:", ";}}}}@media (min-width:", "){&.small-mode{max-width:480px;max-height:480px;bottom:initial;min-height:min-content;.modal-content{flex-grow:0;}}}"], function (props) {
  return props.theme.modal.fontFamily;
}, animations, neutral.breakpoints.tablet, neutral.breakpoints.mobile, neutral.spacings.xSmall, addPx(neutral.breakpoints.mobile, 1));
var StyledHeader = styled.header.withConfig({
  displayName: "Modalstyles__StyledHeader",
  componentId: "sc-yqascu-2"
})(["h1{", " font-size:", ";line-height:", ";color:", ";font-weight:", ";margin:0;}"], function (props) {
  return props.hasCloseIcon ? "\n      padding: ".concat(edgePadding, " ").concat(neutral.spacings.xxxLarge, " 0 ").concat(edgePadding, ";\n    ") : "\n      padding: ".concat(edgePadding, " ").concat(edgePadding, " 0 ").concat(edgePadding, ";\n    ");
}, function (props) {
  return props.theme.modal.titleFontSize.fontSize;
}, function (props) {
  return props.theme.modal.titleFontSize.lineHeight;
}, function (props) {
  return props.theme.modal.titleColor;
}, function (props) {
  return props.theme.modal.titleFontWeight;
});
var StyledCloseButton = styled(Button).withConfig({
  displayName: "Modalstyles__StyledCloseButton",
  componentId: "sc-yqascu-3"
})(["position:absolute;top:", ";right:", ";"], neutral.spacings.xSmall, neutral.spacings.xSmall);
var StyledContent = styled.div.withConfig({
  displayName: "Modalstyles__StyledContent",
  componentId: "sc-yqascu-4"
})(["margin:", " 0;padding:0 ", ";overflow-y:auto;flex-grow:1;"], neutral.spacings.large, edgePadding);
var StyledFooter = styled.footer.withConfig({
  displayName: "Modalstyles__StyledFooter",
  componentId: "sc-yqascu-5"
})(["padding:0 ", " ", " ", ";@media (min-width:", "){.sok-btn:not(:first-child){margin-left:", ";}}"], edgePadding, edgePadding, edgePadding, addPx(neutral.breakpoints.mobile, 1), neutral.spacings.xSmall);
var GlobalModalStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  body.sok-modal-open {\n    height: 100vh;\n    overflow-y: hidden;\n  }\n"])));

export { GlobalModalStyles, StyledCloseButton, StyledContent, StyledFooter, StyledHeader, StyledModal, StyledOverlay, animationSpeed };
//# sourceMappingURL=Modal.styles.js.map
